/**
 * The Builderfest brief. One source of truth, read by both the corner pill's
 * overlay and the pale panel below the fold — so a judge can never be told two
 * different things about the same test.
 *
 * Copy is the founder's, and tracks the product as built: Test 1 is a Slice with
 * a declared cadence, not a vague goal.
 */
export const TESTS = [
  {
    n: "Test 1",
    where: "The Arcade",
    title: "Cut a Slice and put Tokens on it",
    body: "Say the thing you keep meaning to do, as loosely as it lives in your head. MelzAI will refuse to let you ante on it — it is too big — and offer four Slices drawn from your own words. Pick one, say where it lands, then declare a deadline: Quick-Play, Six-Sprint, 30-thon, up to a Yearathon. Then stake Tokens on yourself.",
    expect:
      "a PlayCard carrying one bounded Slice, a declared deadline, and Tokens genuinely moved on a double-entry ledger.",
    cta: "Open PlayForward",
    to: "/playforward",
  },
  {
    n: "Test 2",
    where: "The Hall",
    title: "Empty your head, then watch it get ordered",
    body: "A coat closet with a blank wall in it. Dump everything you are carrying — unsorted, that is the job. MelzAI quotes you a price before he touches it, then gathers the mess into Clusters. Isolate one as a Stack and he sequences it the way a builder schedules a build.",
    expect:
      "Clusters from your own mess, an ordered Stack where position is the dependency, and every fee itemised before you agreed to it.",
    cta: "Open Stageward",
    to: "/stageward/walk",
  },
  {
    n: "Test 3",
    where: "The World",
    title: "Cross between them",
    body: "Return to the map and enter the other door — or cross straight from the PlayCard. Two separate origins, one substrate.",
    expect:
      "continuity. Same identity, same Pouch, same MelzAI quoting your Slice back at you, and one ledger behind both.",
    cta: "Back to the map",
    to: "/",
  },
];

export const JUDGES_CLOSER =
  "Six more Places stand on the map, lit and Not Open Yet. What is submitted is two working Places on one shared architecture — one identity, one Pouch, one MelzAI, carried across the Seam.";

export const JUDGES_LIVE_NOTE =
  "MelzAI runs in pre-vetted Demo Mode by default so nothing can fail in front of you. Every room also carries a Live · Claude toggle — flip it and ask him something no canned demo could hold. It is genuinely live for two calls per room, then it steps back to Demo Mode; this is an open alpha and the compute is real.";
